<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import NumberInput from '$saga/components/NumberInput.svelte';

    import { alignAgesWithCount } from './utils';

    export let ageRules,
        formValues,
        maxRuleValue,
        minRuleValue,
        maxAgeAllowed,
        minAgeAllowed;
</script>

<div class={cn('flex items-center justify-between gap-2xs')}>
    <label for="nbChildren" class="flex text-content-neutral">
        <span class="text-sm">
            {trans('tour.aside_panel.pax_popover.children.label')}
            {#if !minAgeAllowed && (!maxAgeAllowed || maxAgeAllowed >= 18)}
                {trans(
                    'tour.aside_panel.pax_popover.children.no_min_age_and_no_max_age',
                )}
            {:else if ageRules.min.isUnder18Allowed && (!maxAgeAllowed || maxAgeAllowed >= 18)}
                {trans(
                    'tour.aside_panel.pax_popover.children.min_age_older_xxx_and_no_max_age',
                    {
                        '%age%': String(minAgeAllowed),
                    },
                )}
            {/if}
            {#if !minAgeAllowed && ageRules.max.isUnder18Allowed}
                {trans(
                    'tour.aside_panel.pax_popover.children.no_min_age_and_max_age_under_xxx',
                    {
                        '%age%': String(maxAgeAllowed),
                    },
                )}
            {/if}
            {#if ageRules.min.isUnder18Allowed && ageRules.max.isUnder18Allowed}
                {trans(
                    'tour.aside_panel.pax_popover.children.min_age_older_xxx_and_max_age_under_yyy',
                    {
                        '%minAge%': String(minAgeAllowed),
                        '%maxAge%': String(maxAgeAllowed),
                    },
                )}
            {/if}
        </span>
    </label>
    <NumberInput
        bind:value={formValues.children}
        max={maxRuleValue}
        min={minRuleValue}
        id="nbChildren"
        name="nbChildren"
        minusBtnClasses={formValues.children === minRuleValue
            ? 'text-bord-quiet'
            : undefined}
        minusBtnProps={{ disabled: formValues.children === minRuleValue }}
        onDecrement={() => {
            if (formValues.children > minRuleValue) {
                formValues.children = formValues.children - 1;
                formValues.childrenAges = alignAgesWithCount(
                    formValues.childrenAges,
                    formValues.children,
                );
            }
        }}
        onInput={() => {
            formValues.childrenAges = alignAgesWithCount(
                formValues.childrenAges,
                formValues.children,
            );
        }}
        plusBtnClasses={formValues.children === maxRuleValue
            ? 'text-bord-quiet'
            : undefined}
        plusBtnProps={{ disabled: formValues.children === maxRuleValue }}
        onIncrement={() => {
            if (maxRuleValue == null || maxRuleValue > formValues.children) {
                formValues.children = formValues.children + 1;
                formValues.childrenAges = alignAgesWithCount(
                    formValues.childrenAges,
                    formValues.children,
                );
            }
        }}
    />
</div>
